import AdminCustomersList from '@/views/Admin/CustomersList/CustomersList.vue';
import { Route } from '../route.model';

const adminCustomersList = new Route(
  '/admin/customers',
  'customers_list',
  AdminCustomersList,
  {
    requiresAuth: true,
    superRoot: true,
    navbar: {
      name: 'Customers', // TODO apply i18n
      icon: 'customer-center'
    },
    zendesk: {
      disabled: true
    }
  }
);

export { adminCustomersList };
export default adminCustomersList;
